import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Summary } from '../../core/models/summary-card';

@Component({
  selector: 'app-card-summary',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card-summary.component.html',
  styleUrl: './card-summary.component.scss'
})
export class CardSummaryComponent {
 
  @Input() data: Summary[] = [];
  @Input() gridSize: string = 'col-md-6'; 
}
